import Client from './client';

export default class Passphrases extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  get(organization, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/passphrases`, options);
  }

  post(organization, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/passphrases`, {
      ...options,
       method: 'POST',
    });
  }

  getById(organization, id, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/passphrases/${id}`, options);
  }

  postAuthenticationsById(organization, id, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/passphrases/${id}/authentications`, {
      ...options,
       method: 'POST',
    });
  }

}
